/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable array-callback-return */
import { useEffect, useState } from 'react';
import MainContainerLeftControl from '../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import styles from './News.module.scss';
import NewsList from './NewsContent/NewsList/NewsList';
import { useSelector } from 'react-redux';
import NewsAsideListControl from './NewsAside/NewsAsideListControl/NewsAsideListControl';
import { isMobile } from 'react-device-detect';
import defaultImage from '../../../images/object_mask_profile.svg';

const Events = () => {
  // ширина боковой колонки
  const options = '250px';

  const [news, setNews] = useState([]);
  const newsList = useSelector((state) => state.news.events);

  useEffect(() => {
    if (!newsList) return;
    newsList.map((item) => {
      if (item.images.length === 0) {
        item.images.push({ image: defaultImage, cropped_image: defaultImage });
      }
    });
    setNews(newsList);
  }, [newsList]);

  return (
    <section className={styles.news}>
      <MainContainerLeftControl
        widthAside={options}
        logoPosition="fixed"
        data={<NewsAsideListControl logoPosition="fixed" />}>
        {isMobile && <NewsAsideListControl />}
        {news && <NewsList data="events" />}
      </MainContainerLeftControl>
    </section>
  );
};

export default Events;
